import { Fragment } from 'react';
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import { MAIN_SECTION_PADDING_Y } from 'ecosystem-marketplace-core/constants/layout';
import styled from 'styled-components';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StorefrontPartnerTiers from './StorefrontPartnerTiers';
import StorefrontExplainer from './StorefrontExplainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BigMainSection = styled(MainSection).withConfig({
  displayName: "StorefrontFooter__BigMainSection",
  componentId: "sc-8nbr2h-0"
})(["font-size:16px;line-height:28px;"]);
const StorefrontFooter = () => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(StorefrontExplainer, {}), /*#__PURE__*/_jsx(BigMainSection, {
      children: /*#__PURE__*/_jsx(MainSectionInner, {
        children: /*#__PURE__*/_jsx(StorefrontPartnerTiers, {})
      })
    }), /*#__PURE__*/_jsx(MainSection, {
      className: "p-top-0 text-center",
      children: /*#__PURE__*/_jsx(MainSectionInner, {
        divider: true,
        style: {
          paddingTop: MAIN_SECTION_PADDING_Y
        },
        children: /*#__PURE__*/_jsx(UILink, {
          external: true,
          href: "https://legal.hubspot.com/directory-tou",
          iconProps: {
            className: 'hidden'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ecosystem-marketplace-solutions-ui.storefront.termsOfUseLinkText"
          })
        })
      })
    })]
  });
};
export default StorefrontFooter;